// Icons exported from the Figma frame "Inventory / Mobile - Modal" (4038:30453) on the PAVEL
// DRAFT page, via the Dev Mode asset server. Each category icon ships two tones: the design bakes
// one variant per button state and the tone tracks the tab's state.
import CategoryBackgroundSvg from './cat-background.svg';
import CategoryBackgroundActiveSvg from './cat-background-active.svg';
import CategoryBadgeSvg from './cat-badge.svg';
import CategoryBadgeActiveSvg from './cat-badge-active.svg';
import CategoryFeaturedSvg from './cat-featured.svg';
import CategoryFeaturedActiveSvg from './cat-featured-active.svg';
import CategoryFrameSvg from './cat-frame.svg';
import CategoryFrameActiveSvg from './cat-frame-active.svg';
import EquippedCheckSvg from './equipped-check.svg';
import FrameArtworkPng from './frame-artwork.png';
import IconCloseSvg from './icon-close.svg';
import ItemNoneSvg from './item-none.svg';
import TabFriendsSvg from './tab-friends.svg';
import TabFriendsActiveSvg from './tab-friends-active.svg';
import TabInventorySvg from './tab-inventory.svg';
import TabInventoryActiveSvg from './tab-inventory-active.svg';
import TabProfileSvg from './tab-profile.svg';

export {
	CategoryBackgroundActiveSvg,
	CategoryBackgroundSvg,
	CategoryBadgeActiveSvg,
	CategoryBadgeSvg,
	CategoryFeaturedActiveSvg,
	CategoryFeaturedSvg,
	CategoryFrameActiveSvg,
	CategoryFrameSvg,
	EquippedCheckSvg,
	FrameArtworkPng,
	IconCloseSvg,
	ItemNoneSvg,
	TabFriendsActiveSvg,
	TabFriendsSvg,
	TabInventoryActiveSvg,
	TabInventorySvg,
	TabProfileSvg,
};
